module.exports = __webpack_public_path__ + "static/media/20.Total-Station.310e583f.webp";